import { Component, inject, OnInit, AfterViewInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ToggleThemeService } from '@corporate-tailwind/widget'
import { TranslateModule } from '@ngx-translate/core'
import { lang } from 'libs/ui/component/src/lib/corp-date-picker/function/lang'
import * as L from 'leaflet'
import { GeolocationService, GeolocationPosition as GeoPos } from '@corporate-tailwind/geolocation'

const defaultIcon = L.icon({
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
})
L.Marker.prototype.options.icon = defaultIcon

// Icône distincte pour la position utilisateur (point bleu)
const userIcon = L.divIcon({
    className: '',
    html: `<div style="
        width: 16px; height: 16px;
        background: #2563eb;
        border: 3px solid white;
        border-radius: 50%;
        box-shadow: 0 0 6px rgba(37,99,235,0.7);
    "></div>`,
    iconSize: [16, 16],
    iconAnchor: [8, 8],
    popupAnchor: [0, -10]
})

@Component({
    selector: 'app-confirm-delivery',
    imports: [TranslateModule],
    templateUrl: './confirm-delivery.component.html',
    styleUrl: './confirm-delivery.component.scss'
})
export class ConfirmDeliveryComponent implements OnInit, AfterViewInit {
    toggleThemeService = inject(ToggleThemeService)
    route = inject(ActivatedRoute)
    token64: string | null = null
    readonly lang = lang

    private geolocationService = inject(GeolocationService)
    #geolocalisationPosition!: GeoPos
    #map!: L.Map  // ← référence de la carte partagée

    constructor() {
        this.geolocationService.getCurrentPosition().subscribe({
            next: (position) => {
                this.#geolocalisationPosition = position
                // Ajouter le marqueur si la carte est déjà initialisée
                if (this.#map) {
                    this.#addUserMarker()
                }
            },
            error: (err) => console.error('Erreur géolocalisation :', err),
        })
    }

    #addUserMarker(): void {
        L.marker(
            [this.#geolocalisationPosition.latitude, this.#geolocalisationPosition.longitude],
            { icon: userIcon }
        )
            .addTo(this.#map)
            .bindPopup('Ma position')
    }

    ngOnInit(): void {
        this.toggleThemeService.initializeTheme()
        this.token64 = this.route.snapshot.paramMap.get('token64')
    }

    ngAfterViewInit(): void {
        const adresses = [
            { lat: 48.8148, lng: 2.5071, label: '52 rue Jean Jaurès, Champigny-sur-Marne' },
            { lat: 48.8160, lng: 2.5088, label: '17 rue Juliette de Wills, Champigny-sur-Marne' }
        ]

        this.#map = L.map('map', { zoomControl: true })

        L.tileLayer('http://localhost:8080/tile/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap contributors',
            maxZoom: 19
        }).addTo(this.#map)

        // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        //     //L.tileLayer('http://localhost:8080/{z}/{x}/{y}.png', {  // local
        //     attribution: '&copy; OpenStreetMap contributors',
        //     maxZoom: 19
        // }).addTo(map)

        const marqueurs = adresses.map(a =>
            L.marker([a.lat, a.lng])
                .addTo(this.#map)
                .bindPopup(a.label)
                .on('click', () => {
                    console.log('Adresse sélectionnée :', a.label)
                })
        )

        marqueurs[0].openPopup()

        const groupe = L.featureGroup(marqueurs)
        this.#map.fitBounds(groupe.getBounds().pad(0.3))

        // Ajouter le marqueur utilisateur si la géoloc est déjà disponible
        if (this.#geolocalisationPosition) {
            this.#addUserMarker()
        }

        setTimeout(() => {
            this.#map.invalidateSize()
            this.#map.fitBounds(groupe.getBounds().pad(0.3))
        }, 100)
    }

    toggleTheme() { this.toggleThemeService.toggleTheme() }
    toggleDirection() { this.toggleThemeService.toggleDirection() }
    closeWindow() { window.close() }
}
